import classNames from 'classnames'

export function LiveGameIdleVillagers({ idleVillagers, leftSide }) {
	return (
		<div
			className={classNames('flex items-center justify-center flex-row')}
		>
			{idleVillagers > 0 && (
				<>
					<p className="text-[#b1b1b1] text-xl">{idleVillagers}</p>
					<img
						className="w-6 h-6 "
						src="/liveGameIcons/idle_villager_count.png"
						alt=""
					/>
				</>
			)}
		</div>
	)
}
